import { Box, Card, Typography } from '@mui/material'
import { ProgressReportCard } from './ProgressReportCard'
import { useNavigate, useParams } from 'react-router-dom'

export const OrgProgressReports = (): JSX.Element => {
  const { orgId, planId } = useParams()
  const navigate = useNavigate()

  return (
    // TODO: Make sure to move this CSS
    <Card sx={{
      backgroundColor: 'var(--grey-100)',
      borderRadius: '12px',
      padding: '20px 40px 40px 40px',
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
      position: 'relative',
      overflow: 'visible'
    }}
      data-testid='progressReportsCard'
    >
      <Box display='flex' flexDirection='column' gap='1em'>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at Mid-Year and End of Year by completing the Progress Reports.
        </Typography>

        <ProgressReportCard
          title='Mid-Year Progress Report'
          date='01/05/2026'
          description='Complete the Mid-Year Progress Report to share your progress toward your Implementation Plan with START.'
          onButtonClick={() => { navigate('MidYear') }}
          testId='midYearReport'
        />

        <ProgressReportCard
          title='End of Year Progress Report'
          date='05/05/2026'
          description='Complete the End of Year Progress Report to share your progress toward your Implementation Plan with START.'
          onButtonClick={() => { console.log(`End of Year for org: ${orgId ?? '0'}, ${planId ?? '0'}`) }}
          testId='endYearReport'
        />
      </Box>
    </Card>
  )
}
